import CustomerConstants from "./Customer";

const SettingApi = {
	LOYALTY: {
		loyalty_popup_wellcome_desk: {
			default: "",
			key: "loyalty_popup_wellcome_desk",
		},
		loyalty_popup_wellcome_mob: {
			default: "",
			key: "loyalty_popup_wellcome_mob",
		},
		after_login_url: {
			default: "https://namperfume.net",
			key: "after_login_url",
		},
		after_login_first_url: {
			default:
				CustomerConstants.LINK_ROUTER.CUSTOMER.INDEX +
				CustomerConstants.LINK_ROUTER.CUSTOMER.MY_PROFILE,
			key_mobile: "after_login_first_mobile_url",
			key_desktop: "after_login_first_desktop_url",
		},
		after_verify_url: { default: "", key: "after_verify_url" },
		after_establish_url: "after_establish_url",
		setting_limit_otp: "setting_limit_otp",
	},
	FEEDBACK: {
		get_comment_on_select_options: "setting_stores_feedback",
	},
	QUICKCONTACT: {
		k_title_live: "sociallive_textbox_live",
		k_title_contact: "sociallive_textbox_messenger",
	},
	REWARD: {
		k_reward_img: "reward_website_banner",
	},
};

export default SettingApi;
